module.exports = __webpack_public_path__ + "static/media/pokemon.3cfd5e85.svg";